import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DossierDTO } from "src/app/core/services/business/model/scoring/dossier-dto";
import { ScoringService } from "src/app/core/services/business/service/scoring.service";
import { ReportViewerModalComponent } from "../../modal/viewer/report-viewer-modal/report-viewer-modal.component";

@Component({
  selector: "app-scoring",
  templateUrl: "./scoring.component.html",
  styleUrls: ["./scoring.component.scss"],
})
export class ScoringComponent implements OnInit {
  @Input() requestId: any;

  dossiers: DossierDTO[];

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private _scoringService: ScoringService
  ) {}

  ngOnInit() {
    this.findAllDossierByRequest(this.requestId);
  }

  findAllDossierByRequest(requestId) {
    this._scoringService.findAllDossierByRequest(requestId).subscribe(
      (data) => {
        this.dossiers = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  Apercu(dossierid) {
    const modalRef = this.modalService.open(ReportViewerModalComponent, {
      size: "lg",
      backdrop: "static",
      centered: true,
    });

    this._scoringService.getPdfByDossierId(dossierid).subscribe((blob) => {
      modalRef.componentInstance.destination = blob;
    });

    modalRef.result.then(
      (data) => {},
      (reason) => {}
    );
  }
}
